__turbopack_context__.v({
  "className": "noto_sans_oriya_7c29f065-module__rlHQMa__className",
});
